<template>
  <div id="withdrawct" class="contentmodaldiv" data-backdrop="false">
    <div class="modaldiv">
      <div class="contentmodal animate__animated animate__bounceInDown">
        <button class="closepopup" data-dismiss="modal">
          <i class="fas fa-times"></i>
        </button>
        <div class="login">
          <div class="logopopup">
            <img src="/static/img/logo/main_logo_20221004223046.png" />
          </div>
          <h1>
            <img src="/static/img/landing/cd.png" />
            ถอนเงิน
          </h1>
          <h1 class="text-center">
            เทิร์นโอเวอร์ที่ต้องทำ : {{
              UserInfo.BonusInfo.nowTurnover
            }} / {{
              UserInfo.BonusInfo.needTurnover
            }}
          </h1>
          
          <div class="nmwdcontain">
            <hr class="x-hr-border-glow mb-1 mt-1" />
            <div class="detailwd accountct">
              <table align="center">
                <tbody>
                  <tr>
                    <td>
                      <img
                        :style="{
                          'background-color': getBankColorwithCode(
                            UserInfo.BankCode
                          ),
                          padding:
                            UserInfo.BankCode == 'co.th.truemoney.wallet'
                              ? ''
                              : '5px',
                        }"
                        v-bind:src="getBankImgwithCode(UserInfo.BankCode)"
                        class="img-rounded img-responsive"
                      />
                    </td>
                    <td>
                      ธนาคาร: {{ getBankName(UserInfo.BankCode) }} <br />
                      <span
                        >เลขบัญชี:
                        {{ UserInfo.BankAccount | formatAccNo }}</span
                      ><br />
                      <span>ชื่อบัญชี: {{ UserInfo.userName.fullName }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="headerbankdt mt-3 mb-1">
              ยอดเงินคงเหลือ
              <i class="fas fa-redo-alt cursor-pointer"></i>&nbsp;<span
                class=""
                >{{ UserInfo.internalWallet.gameWallet }}</span
              >
              บาท
            </div>
            <div class=" form-group mb-4">
              <h6 class="text-white text-center">ถอนขั้นต่ำ {{ this.Prefix.Withdraw.minWithdraw }} บาท</h6>
              <div class="el-input">
                <input
                  placeholder="กรอกจำนวนเงิน"
                  type="tel"
                  id="withdraw_amount"
                  class="inputstyle text-center p-0 py-2"
                  v-model="amount"
                />
              </div>
            </div>
            <button
              type="button"
              class="btnLogin mt-0 mb-3"
              @click="Withdraw()"
            >
              <span>
                ถอนเงิน
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="overlaymodal"></div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { PrefixMixins } from "@/mixins/Prefix.js";
import { BankMixins } from "@/mixins/BankService.js";

import { Withdraw } from "@/services/modules/withdraw.js";
import moment from "moment";

export default {
  name: "WithdrawForm",
  mixins: [UserInfoMixins, PrefixMixins, BankMixins],

  data() {
    return {
      amount: "",
    };
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "getPrefix",
    ]),
  },
  methods: {
    async copybank(item) {
      this.$copyText(item, this.$refs.withdraw);
      this.$swal.fire("คัดลอกแล้ว", "", "success");
    },
    async Withdraw() {
      await Withdraw(this.amount, this.Prefix.Withdraw.minWithdraw, (res) => {
        if (res.status) {
          this.$swal.fire("Success!", "", "success");
        } else {
          this.$swal.fire(res.message, "", "error");
        }
      });
    },
  },
  async mounted() {
    $(".overlaymodal").on("click", function() {
      $("#withdrawct").modal("hide");
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/form/WithdrawForm.vue